import dayjs from 'dayjs';
import { DatePickerQuickSelectPresets, DatePickerQuickSelectRangePresets } from './datePicker.types';
var formatFullMonthAndYear = function (_a) {
    var date = _a.date;
    return dayjs(date).format('MMMM YYYY');
};
var formatFullMonth = function (_a) {
    var date = _a.date;
    return dayjs(date).format('MMMM');
};
var formatFullYear = function (_a) {
    var date = _a.date;
    return dayjs(date).format('YYYY');
};
var formatDayName = function (_a) {
    var date = _a.date;
    return dayjs(date).format('dd').substring(0, 1);
};
var formatDayNumber = function (_a) {
    var date = _a.date;
    return dayjs(date).get('date');
};
export var DatePickerStringsForDocs = function () {
    return {
        /** String to display in the display month label */
        'datepicker.currentDisplayMonth': formatFullMonth,
        /** String to display in the display month and year label */
        'datepicker.currentDisplayMonthAndYear': formatFullMonthAndYear,
        /** String to display in the display year label */
        'datepicker.currentDisplayYear': formatFullYear,
        /** String to display in the day name label */
        'datepicker.dayName': formatDayName,
        /** String to display in the day label */
        'datepicker.dayNumber': formatDayNumber,
        /** String to display in the previous month label */
        'datepicker.goToPreviousMonthLabel': 'Go to previous month',
        /** String to display in the next month label */
        'datepicker.goToNextMonthLabel': 'Go to next month',
        /** String to display in the aria-label for the optional "X" clear button */
        'datepicker.input.clearBtnLabel': 'Clear selected',
        /** String to display in the aria-label for the ChevronUp icon when a Dropdown Datepicker is open */
        'datepicker.input.closePickerBtnLabel': 'Close picker',
        /** String to display in the aria-label for the ChevronDown icon when a Dropdown Datepicker is closed */
        'datepicker.input.openPickerBtnLabel': 'Open picker',
        /** String to display in the month label */
        'datepicker.monthName': formatFullMonth,
        /** String to display in the quick select header label */
        'datepicker.quickSelectHeader': 'Quick select',
        /** String to display in the quick select labels */
        'datepicker.quickSelectLabel': function (_a) {
            var quickSelect = _a.quickSelect;
            switch (quickSelect) {
                case DatePickerQuickSelectPresets.START_OF_NEXT_MONTH:
                    return 'Start of next month';
                case DatePickerQuickSelectPresets.START_OF_NEXT_QUARTER:
                    return 'Start of next quarter';
                case DatePickerQuickSelectPresets.START_OF_NEXT_WEEK:
                    return 'Start of next week';
                case DatePickerQuickSelectPresets.START_OF_TWO_WEEKS_FROM_NOW:
                    return 'Start of two weeks from now';
                case DatePickerQuickSelectPresets.TODAY:
                    return 'Today';
                case DatePickerQuickSelectRangePresets.NEXT_NINETY_DAYS:
                    return 'Next 90 days';
                case DatePickerQuickSelectRangePresets.NEXT_SIXTY_DAYS:
                    return 'Next 60 days';
                case DatePickerQuickSelectRangePresets.NEXT_TWO_WEEKS:
                    return 'Next two weeks';
                case DatePickerQuickSelectRangePresets.NEXT_WEEK:
                    return 'Next week';
                case DatePickerQuickSelectRangePresets.THIS_WEEK:
                    return 'This week';
                default:
                    throw new Error("Unknown quick select preset value of \"".concat(quickSelect, "\" was provided"));
            }
        },
        /** String to display in the year label */
        'datepicker.yearName': formatFullYear,
    };
};
export var DatePickerStrings = DatePickerStringsForDocs();
